export default __webpack_public_path__ + "static/media/exp_R.93081bc0.png";